import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { authClient } from '../common/helper'
import { LanguageContext } from '../context/LanguageContext'
import '../style/Logout.scss'
import '../style/Navbar.scss'
import Loader from './Loader'


const Logout = () =>{
    const { strings } =useContext(LanguageContext)
    const { isLoading } = useSelector(state=>state.languageChange)
    
    const onLoginClick = () =>{
        authClient.authorize()
    }
    
    if(isLoading) return <Loader languageFetched={!isLoading} />
    
    return (
        <div>
            <div className='navbar-main'>
                <div className='navbar-container'>
                    <div className='lvt-icon-container'>
                        <div className="lvt-icon"></div>
                    </div>
                    <div className="navbar-title-container">
                        <div className='navbar-title'>{strings['showAndGoText']}</div>
                    </div>
                </div>
            </div>
            <div className='logout'>
                <h2>{strings.logOutDescription}</h2>
                <button className='btn-login' onClick={ onLoginClick }  >{strings.logIn}</button>
            </div>
        </div>
    )
}
export default Logout